import { createPinia } from "pinia";
import { axiosFactory } from "@/tools/axios-factory";
const b = import.meta.env.VITE_APP_ADDRESS?.toString();


const pinia = createPinia();
// give the plugin to pinia
pinia.use(({ store }) => {
  store.axiosFactory = new axiosFactory();
  store.urlRoot = b;
});

export default pinia;
